import { render, staticRenderFns } from "./RelatieSelect.vue?vue&type=template&id=ba776a68"
import script from "./RelatieSelect.vue?vue&type=script&lang=js"
export * from "./RelatieSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports